module.exports = __webpack_public_path__ + "img/main-logo.bc626bf0.png";